import React from 'react';

const steps = [
  {
    num: '01',
    label: 'Browse',
    sub: 'Check services and availability in the calendar',
  },
  {
    num: '02',
    label: 'Request',
    sub: 'Tap a date, send me a message via WhatsApp',
  },
  {
    num: '03',
    label: 'Sorted',
    sub: 'I\'ll get back to you within a few hours. If it\'s urgent, just call.',
  },
];

export default function HowItWorks() {
  return (
    <section style={{
      background: '#FDFCFF',
      padding: '3.5rem 0',
      borderTop: '0.5px solid #E8E0F0',
    }}>
      <div className="content-column">
        <div className="section-tag">How it works</div>
        <h2 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '1.75rem',
          lineHeight: 1.2,
          color: '#1A1530',
          marginTop: 0,
          marginBottom: '2rem',
        }}>
          Simple as{' '}
          <em style={{ fontWeight: 400, color: '#7B6EC4' }}>that</em>
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {steps.map((step) => (
            <div key={step.num} style={{ display: 'flex', alignItems: 'center', gap: '1.1rem' }}>
              <div style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #EDE8FB, #D4CAF0)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                fontFamily: "'Playfair Display', serif",
                fontWeight: 600,
                fontSize: '1rem',
                color: '#7B6EC4',
              }}>
                {step.num}
              </div>
              <div>
                <div style={{
                  fontWeight: 600,
                  fontSize: '0.97rem',
                  color: '#1A1530',
                  marginBottom: '0.15rem',
                }}>
                  {step.label}
                </div>
                <div style={{
                  fontSize: '0.85rem',
                  fontWeight: 300,
                  color: '#6A6080',
                  lineHeight: 1.5,
                }}>
                  {step.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
